// SocialCheck — öffentliche Preiseseite (DE / FR / IT / EN)
export const preiseTranslations = {
  de: {
    nav: { login: "Anmelden", demo: "Demo anfordern" },
    hero: {
      badge: "SocialCheck · powered by KEWAG",
      title1: "Nicht noch ein Tool.", title2: "Echte Entlastung.",
      sub1: "Bei SocialCheck bezahlen Sie nicht für Software zum Selbermachen. Sie bezahlen dafür, dass ",
      sub2: " Ihr Social Media plant, erstellt, vorbereitet, veröffentlicht und auswertet.",
      ampel: "Sie prüfen nur mit der Ampel.", ampelRest: "Wir machen den Rest.",
      ctaKurzcheck: "Kurzcheck buchen", ctaDemo: "Demo anfordern",
      cardTop: "Der Kunde prüft nur mit der Ampel.", cardBottom: "KEWAG macht den Rest.",
      trust: ["Alles aus einer Hand", "Persönlicher Ansprechpartner", "Transparente Preise", "Echte Menschen in der Schweiz", "Klare Pakete", "Keine versteckten Kosten"],
    },
    how: {
      title: "So einfach ist SocialCheck",
      subtitle: "Kein Login-Stress, keine Vorlagen, keine Selbstbedienung. KEWAG übernimmt die Arbeit — Sie geben nur grünes Licht.",
      kewagLabel: "KEWAG übernimmt",
      kewagDoes: ["Themen- & Redaktionsplanung", "Professionelle Texte", "Bild- & Designideen", "Veröffentlichung auf Ihren Kanälen", "Monatliches Reporting", "Persönlicher Ansprechpartner"],
      youTitle: "Sie machen nur eins:",
      youBody: "Beitrag ansehen und mit der Ampel freigeben — grün, orange oder rot. Mit einem Klick, in unter einer Minute.",
      youCta: "Jetzt starten",
    },
    pricing: {
      title: "Wählen Sie das Paket, das zu Ihrem Unternehmen passt.",
      subtitle: "Klare, transparente Pakete für Schweizer KMU — ohne versteckte Kosten.",
      footnote: "Alle Preise in CHF, exkl. MwSt. · Mindestvertragsdauer 3 Monate · danach monatlich kündbar.",
      einmalig: "einmalig", monat: "/ Monat", badge: "Beliebtestes Paket",
      taglines: { KURZCHECK: "Für Kunden, die zuerst wissen wollen, wo sie stehen.", START: "Für den einfachen Start", BASIC: "Für konstante Sichtbarkeit", GROW: "Für mehr Reichweite", PRO: "Für ambitionierte KMU" },
      cta: { KURZCHECK: "Kurzcheck buchen", START: "START wählen", BASIC: "BASIC wählen", GROW: "GROW wählen", PRO: "PRO wählen" },
      features: {
        KURZCHECK: ["Social-Media-Kurzcheck", "Website-Kurzcheck light", "Ampel-Bewertung", "3 konkrete Empfehlungen", "PDF-Report", "Empfehlung für das passende Paket"],
        START: ["2 Beiträge / Monat", "1 Hauptkanal", "Google Business light", "Einfache Texte", "Einfache Bilder", "Ampel-Freigabe", "Veröffentlichung", "Mini-Report"],
        BASIC: ["4 Beiträge / Monat", "1–2 Kanäle inklusive", "Themenplanung", "Professionelle Texte", "Bild- & Designideen", "Ampel-Freigabe", "Veröffentlichung", "Monatsreport", "Website-Kurzcheck (Start)"],
        GROW: ["6 Beiträge / Monat", "Bis 3 Kanäle inklusive", "Google Business Beitrag", "Themen- & Hashtag-Vorschläge", "Ampel-Freigabe", "Veröffentlichung", "Monatsreport mit Empfehlungen"],
        PRO: ["8 Beiträge / Monat", "Bis 3 Kanäle inklusive", "Monatliche Strategie", "Professionelle Texte", "Bild- & Designideen", "Ampel-Freigabe", "Veröffentlichung", "Erweiterter Monatsreport", "30 Min. Beratung / Monat", "Priorisierte Betreuung"],
      },
    },
    channels: {
      title: "Die richtigen Kanäle für Ihr Unternehmen",
      subtitle: "Wir betreuen die Kanäle, auf denen Ihre Kundschaft wirklich ist — von Instagram über Facebook bis Google Business.",
      moreTitle: "Mehr als 3 Kanäle?", morePre: "Jeder zusätzliche Kanal ab ", morePrice: "CHF 150.– / Monat", morePost: ". Flexibel zubuchbar.",
    },
    excluded: {
      title: "Nicht im Paketpreis enthalten",
      subtitle: "Damit alles transparent bleibt — diese Leistungen sind bewusst nicht inbegriffen:",
      items: ["Social Ads Budget (separat)", "Fotoshooting / Video-Dreh", "Reels / Videos (aufwendig)", "Community Management (umfassend)", "Website-Anpassungen oder neue Website", "SEO, SEA, Shop, Programmierung", "Grosse Kampagnen und Sonderprojekte"],
      note: "Diese Leistungen bieten wir gerne separat über KEWAG an.",
    },
    addons: {
      title: "Zusatzleistungen", subtitle: "Auf Wunsch flexibel zubuchbar:",
      items: [
        { label: "Zusätzlicher Kanal", price: "ab CHF 150.– / Monat" },
        { label: "Zusätzlicher Beitrag", price: "ab CHF 140.–" },
        { label: "Design-Beitrag", price: "ab CHF 190.–" },
        { label: "Reel / Kurzvideo", price: "ab CHF 290.–" },
        { label: "Community Management light", price: "ab CHF 290.– / Monat" },
        { label: "Social Ads Betreuung", price: "ab CHF 490.– / Monat · Budget separat" },
        { label: "Blog- / LinkedIn-Beitrag", price: "ab CHF 390.–" },
        { label: "Fotoshooting / Video-Dreh", price: "auf Anfrage" },
      ],
    },
    cta: {
      title: "Bereit, Ihre Social Media in den grünen Bereich zu bringen?",
      body: "Starten Sie mit dem Kurzcheck oder fordern Sie eine unverbindliche Demo an. Persönlich, aus der Schweiz, ohne versteckte Kosten.",
      ctaKurzcheck: "Kurzcheck buchen", ctaDemo: "Demo anfordern",
      footerNote: "Alle Preise in CHF, exkl. MwSt. · Mindestvertragsdauer 3 Monate · monatlich kündbar.",
    },
  },

  fr: {
    nav: { login: "Se connecter", demo: "Demander une démo" },
    hero: {
      badge: "SocialCheck · powered by KEWAG",
      title1: "Pas un outil de plus.", title2: "Un vrai soulagement.",
      sub1: "Avec SocialCheck, vous ne payez pas un logiciel à utiliser vous-même. Vous payez pour que ",
      sub2: " planifie, crée, prépare, publie et analyse vos réseaux sociaux.",
      ampel: "Vous validez juste avec les feux.", ampelRest: "Nous faisons le reste.",
      ctaKurzcheck: "Réserver le Kurzcheck", ctaDemo: "Demander une démo",
      cardTop: "Le client valide juste avec les feux.", cardBottom: "KEWAG fait le reste.",
      trust: ["Tout d’une seule main", "Interlocuteur personnel", "Prix transparents", "De vraies personnes en Suisse", "Forfaits clairs", "Aucun coût caché"],
    },
    how: {
      title: "SocialCheck, c’est simple",
      subtitle: "Pas de stress de connexion, pas de modèles, pas de self-service. KEWAG s’occupe du travail — vous donnez juste le feu vert.",
      kewagLabel: "KEWAG s’en charge",
      kewagDoes: ["Planification éditoriale & thèmes", "Textes professionnels", "Idées visuelles & design", "Publication sur vos canaux", "Reporting mensuel", "Interlocuteur personnel"],
      youTitle: "Vous ne faites qu’une chose :",
      youBody: "Regarder la publication et valider avec les feux — vert, orange ou rouge. En un clic, en moins d’une minute.",
      youCta: "Commencer",
    },
    pricing: {
      title: "Choisissez le forfait adapté à votre entreprise.",
      subtitle: "Des forfaits clairs et transparents pour les PME suisses — sans coûts cachés.",
      footnote: "Tous les prix en CHF, hors TVA · Durée minimale de 3 mois · résiliable mensuellement ensuite.",
      einmalig: "unique", monat: "/ mois", badge: "Forfait le plus populaire",
      taglines: { KURZCHECK: "Pour ceux qui veulent d’abord savoir où ils en sont.", START: "Pour un démarrage simple", BASIC: "Pour une visibilité constante", GROW: "Pour plus de portée", PRO: "Pour les PME ambitieuses" },
      cta: { KURZCHECK: "Réserver le Kurzcheck", START: "Choisir START", BASIC: "Choisir BASIC", GROW: "Choisir GROW", PRO: "Choisir PRO" },
      features: {
        KURZCHECK: ["Bref check réseaux sociaux", "Bref check site web (light)", "Évaluation feux tricolores", "3 recommandations concrètes", "Rapport PDF", "Recommandation du forfait adapté"],
        START: ["2 publications / mois", "1 canal principal", "Google Business light", "Textes simples", "Images simples", "Validation par feux", "Publication", "Mini-rapport"],
        BASIC: ["4 publications / mois", "1–2 canaux inclus", "Planification des thèmes", "Textes professionnels", "Idées visuelles & design", "Validation par feux", "Publication", "Rapport mensuel", "Bref check site web (Start)"],
        GROW: ["6 publications / mois", "Jusqu’à 3 canaux inclus", "Publication Google Business", "Suggestions de thèmes & hashtags", "Validation par feux", "Publication", "Rapport mensuel avec recommandations"],
        PRO: ["8 publications / mois", "Jusqu’à 3 canaux inclus", "Stratégie mensuelle", "Textes professionnels", "Idées visuelles & design", "Validation par feux", "Publication", "Rapport mensuel étendu", "30 min. de conseil / mois", "Suivi prioritaire"],
      },
    },
    channels: {
      title: "Les bons canaux pour votre entreprise",
      subtitle: "Nous gérons les canaux où se trouve réellement votre clientèle — d’Instagram à Facebook jusqu’à Google Business.",
      moreTitle: "Plus de 3 canaux ?", morePre: "Chaque canal supplémentaire dès ", morePrice: "CHF 150.– / mois", morePost: ". À ajouter en toute flexibilité.",
    },
    excluded: {
      title: "Non inclus dans le prix du forfait",
      subtitle: "Pour que tout reste transparent — ces prestations ne sont volontairement pas incluses :",
      items: ["Budget Social Ads (séparé)", "Shooting photo / tournage vidéo", "Reels / vidéos (complexes)", "Community management (complet)", "Adaptations ou nouveau site web", "SEO, SEA, shop, programmation", "Grandes campagnes et projets spéciaux"],
      note: "Nous proposons volontiers ces prestations séparément via KEWAG.",
    },
    addons: {
      title: "Prestations supplémentaires", subtitle: "À ajouter en toute flexibilité :",
      items: [
        { label: "Canal supplémentaire", price: "dès CHF 150.– / mois" },
        { label: "Publication supplémentaire", price: "dès CHF 140.–" },
        { label: "Publication design", price: "dès CHF 190.–" },
        { label: "Reel / vidéo courte", price: "dès CHF 290.–" },
        { label: "Community management light", price: "dès CHF 290.– / mois" },
        { label: "Gestion Social Ads", price: "dès CHF 490.– / mois · budget séparé" },
        { label: "Article blog / LinkedIn", price: "dès CHF 390.–" },
        { label: "Shooting photo / tournage vidéo", price: "sur demande" },
      ],
    },
    cta: {
      title: "Prêt à faire passer vos réseaux sociaux au vert ?",
      body: "Commencez par le Kurzcheck ou demandez une démo sans engagement. Personnel, depuis la Suisse, sans coûts cachés.",
      ctaKurzcheck: "Réserver le Kurzcheck", ctaDemo: "Demander une démo",
      footerNote: "Tous les prix en CHF, hors TVA · Durée minimale de 3 mois · résiliable mensuellement.",
    },
  },

  it: {
    nav: { login: "Accedi", demo: "Richiedi una demo" },
    hero: {
      badge: "SocialCheck · powered by KEWAG",
      title1: "Non un altro tool.", title2: "Un vero sollievo.",
      sub1: "Con SocialCheck non paghi un software da usare da solo. Paghi affinché ",
      sub2: " pianifichi, crei, prepari, pubblichi e analizzi i tuoi social media.",
      ampel: "Tu approvi solo con il semaforo.", ampelRest: "Al resto pensiamo noi.",
      ctaKurzcheck: "Prenota il Kurzcheck", ctaDemo: "Richiedi una demo",
      cardTop: "Il cliente approva solo con il semaforo.", cardBottom: "KEWAG fa il resto.",
      trust: ["Tutto da un unico partner", "Referente personale", "Prezzi trasparenti", "Persone reali in Svizzera", "Pacchetti chiari", "Nessun costo nascosto"],
    },
    how: {
      title: "SocialCheck è così semplice",
      subtitle: "Niente stress di login, niente template, niente self-service. KEWAG fa il lavoro — tu dai solo il via libera.",
      kewagLabel: "Se ne occupa KEWAG",
      kewagDoes: ["Pianificazione temi & editoriale", "Testi professionali", "Idee per immagini & design", "Pubblicazione sui tuoi canali", "Reporting mensile", "Referente personale"],
      youTitle: "Tu fai solo una cosa:",
      youBody: "Guardare il post e approvarlo con il semaforo — verde, arancione o rosso. Con un clic, in meno di un minuto.",
      youCta: "Inizia ora",
    },
    pricing: {
      title: "Scegli il pacchetto adatto alla tua azienda.",
      subtitle: "Pacchetti chiari e trasparenti per le PMI svizzere — senza costi nascosti.",
      footnote: "Tutti i prezzi in CHF, IVA escl. · Durata minima 3 mesi · poi disdicibile mensilmente.",
      einmalig: "una tantum", monat: "/ mese", badge: "Pacchetto più popolare",
      taglines: { KURZCHECK: "Per chi vuole prima sapere a che punto è.", START: "Per iniziare in modo semplice", BASIC: "Per una visibilità costante", GROW: "Per una maggiore portata", PRO: "Per PMI ambiziose" },
      cta: { KURZCHECK: "Prenota il Kurzcheck", START: "Scegli START", BASIC: "Scegli BASIC", GROW: "Scegli GROW", PRO: "Scegli PRO" },
      features: {
        KURZCHECK: ["Check rapido social media", "Check rapido sito web (light)", "Valutazione a semaforo", "3 raccomandazioni concrete", "Report PDF", "Consiglio sul pacchetto adatto"],
        START: ["2 post / mese", "1 canale principale", "Google Business light", "Testi semplici", "Immagini semplici", "Approvazione a semaforo", "Pubblicazione", "Mini-report"],
        BASIC: ["4 post / mese", "1–2 canali inclusi", "Pianificazione temi", "Testi professionali", "Idee per immagini & design", "Approvazione a semaforo", "Pubblicazione", "Report mensile", "Check rapido sito web (Start)"],
        GROW: ["6 post / mese", "Fino a 3 canali inclusi", "Post Google Business", "Proposte di temi & hashtag", "Approvazione a semaforo", "Pubblicazione", "Report mensile con raccomandazioni"],
        PRO: ["8 post / mese", "Fino a 3 canali inclusi", "Strategia mensile", "Testi professionali", "Idee per immagini & design", "Approvazione a semaforo", "Pubblicazione", "Report mensile esteso", "30 min. di consulenza / mese", "Assistenza prioritaria"],
      },
    },
    channels: {
      title: "I canali giusti per la tua azienda",
      subtitle: "Gestiamo i canali dove sono davvero i tuoi clienti — da Instagram a Facebook fino a Google Business.",
      moreTitle: "Più di 3 canali?", morePre: "Ogni canale aggiuntivo da ", morePrice: "CHF 150.– / mese", morePost: ". Aggiungibile in modo flessibile.",
    },
    excluded: {
      title: "Non incluso nel prezzo del pacchetto",
      subtitle: "Per la massima trasparenza — questi servizi non sono volutamente inclusi:",
      items: ["Budget Social Ads (a parte)", "Servizio foto / riprese video", "Reel / video (elaborati)", "Community management (completo)", "Modifiche o nuovo sito web", "SEO, SEA, shop, programmazione", "Grandi campagne e progetti speciali"],
      note: "Offriamo volentieri questi servizi separatamente tramite KEWAG.",
    },
    addons: {
      title: "Servizi aggiuntivi", subtitle: "Aggiungibili in modo flessibile:",
      items: [
        { label: "Canale aggiuntivo", price: "da CHF 150.– / mese" },
        { label: "Post aggiuntivo", price: "da CHF 140.–" },
        { label: "Post design", price: "da CHF 190.–" },
        { label: "Reel / video breve", price: "da CHF 290.–" },
        { label: "Community management light", price: "da CHF 290.– / mese" },
        { label: "Gestione Social Ads", price: "da CHF 490.– / mese · budget a parte" },
        { label: "Articolo blog / LinkedIn", price: "da CHF 390.–" },
        { label: "Servizio foto / riprese video", price: "su richiesta" },
      ],
    },
    cta: {
      title: "Pronto a portare i tuoi social nel verde?",
      body: "Inizia con il Kurzcheck o richiedi una demo senza impegno. Personale, dalla Svizzera, senza costi nascosti.",
      ctaKurzcheck: "Prenota il Kurzcheck", ctaDemo: "Richiedi una demo",
      footerNote: "Tutti i prezzi in CHF, IVA escl. · Durata minima 3 mesi · disdicibile mensilmente.",
    },
  },

  en: {
    nav: { login: "Sign in", demo: "Request a demo" },
    hero: {
      badge: "SocialCheck · powered by KEWAG",
      title1: "Not just another tool.", title2: "Real relief.",
      sub1: "With SocialCheck you don’t pay for do-it-yourself software. You pay for ",
      sub2: " to plan, create, prepare, publish and analyse your social media.",
      ampel: "You only check with the traffic light.", ampelRest: "We do the rest.",
      ctaKurzcheck: "Book the quick check", ctaDemo: "Request a demo",
      cardTop: "The client only checks with the traffic light.", cardBottom: "KEWAG does the rest.",
      trust: ["Everything from one source", "Personal contact person", "Transparent prices", "Real people in Switzerland", "Clear packages", "No hidden costs"],
    },
    how: {
      title: "SocialCheck is this simple",
      subtitle: "No login stress, no templates, no self-service. KEWAG does the work — you just give the green light.",
      kewagLabel: "KEWAG handles it",
      kewagDoes: ["Topic & editorial planning", "Professional copy", "Image & design ideas", "Publishing on your channels", "Monthly reporting", "Personal contact person"],
      youTitle: "You do just one thing:",
      youBody: "Review the post and approve it with the traffic light — green, amber or red. In one click, in under a minute.",
      youCta: "Get started",
    },
    pricing: {
      title: "Choose the package that fits your business.",
      subtitle: "Clear, transparent packages for Swiss SMEs — with no hidden costs.",
      footnote: "All prices in CHF, excl. VAT · Minimum term 3 months · then cancellable monthly.",
      einmalig: "one-time", monat: "/ month", badge: "Most popular",
      taglines: { KURZCHECK: "For those who first want to know where they stand.", START: "For an easy start", BASIC: "For constant visibility", GROW: "For more reach", PRO: "For ambitious SMEs" },
      cta: { KURZCHECK: "Book the quick check", START: "Choose START", BASIC: "Choose BASIC", GROW: "Choose GROW", PRO: "Choose PRO" },
      features: {
        KURZCHECK: ["Social media quick check", "Website quick check (light)", "Traffic-light rating", "3 concrete recommendations", "PDF report", "Recommendation for the right plan"],
        START: ["2 posts / month", "1 main channel", "Google Business light", "Simple copy", "Simple images", "Traffic-light approval", "Publishing", "Mini report"],
        BASIC: ["4 posts / month", "1–2 channels included", "Topic planning", "Professional copy", "Image & design ideas", "Traffic-light approval", "Publishing", "Monthly report", "Website quick check (Start)"],
        GROW: ["6 posts / month", "Up to 3 channels included", "Google Business post", "Topic & hashtag suggestions", "Traffic-light approval", "Publishing", "Monthly report with recommendations"],
        PRO: ["8 posts / month", "Up to 3 channels included", "Monthly strategy", "Professional copy", "Image & design ideas", "Traffic-light approval", "Publishing", "Extended monthly report", "30 min. consulting / month", "Priority support"],
      },
    },
    channels: {
      title: "The right channels for your business",
      subtitle: "We manage the channels where your customers really are — from Instagram to Facebook to Google Business.",
      moreTitle: "More than 3 channels?", morePre: "Each additional channel from ", morePrice: "CHF 150.– / month", morePost: ". Flexibly add-on.",
    },
    excluded: {
      title: "Not included in the package price",
      subtitle: "So everything stays transparent — these services are intentionally not included:",
      items: ["Social ads budget (separate)", "Photo shoot / video production", "Reels / videos (elaborate)", "Community management (comprehensive)", "Website changes or new website", "SEO, SEA, shop, programming", "Large campaigns and special projects"],
      note: "We’re happy to offer these services separately via KEWAG.",
    },
    addons: {
      title: "Add-on services", subtitle: "Flexibly add-on on request:",
      items: [
        { label: "Additional channel", price: "from CHF 150.– / month" },
        { label: "Additional post", price: "from CHF 140.–" },
        { label: "Design post", price: "from CHF 190.–" },
        { label: "Reel / short video", price: "from CHF 290.–" },
        { label: "Community management light", price: "from CHF 290.– / month" },
        { label: "Social ads management", price: "from CHF 490.– / month · budget separate" },
        { label: "Blog / LinkedIn article", price: "from CHF 390.–" },
        { label: "Photo shoot / video production", price: "on request" },
      ],
    },
    cta: {
      title: "Ready to bring your social media into the green?",
      body: "Start with the quick check or request a no-obligation demo. Personal, from Switzerland, with no hidden costs.",
      ctaKurzcheck: "Book the quick check", ctaDemo: "Request a demo",
      footerNote: "All prices in CHF, excl. VAT · Minimum term 3 months · cancellable monthly.",
    },
  },
};
